import Vue from 'vue'
import Router from 'vue-router'
import store from '../store/store.js'
import website from '@/components/website'
// =============== /reg_step =======================
import email_step from '@/components/website/registerSteps/email_step'
import otp_step from '@/components/website/registerSteps/otp_step'
import password_step from '@/components/website/registerSteps/password_step'

import enforce2faRegister from '@/components/website/security/twoFaAfterLoginRegister.vue'
import individual_step1 from '@/components/website/registerSteps/individual/individual_step1'
import individual_step2 from '@/components/website/registerSteps/individual/individual_step2'
import individual_step3 from '@/components/website/registerSteps/individual/individual_step3'
import individual_step3_doc from '@/components/website/registerSteps/individual/individual_step3_doc'
import corporate_step1 from '@/components/website/registerSteps/corporate/corporate_step1'
import corporate_step2 from '@/components/website/registerSteps/corporate/corporate_step2'
import corporate_step3 from '@/components/website/registerSteps/corporate/corporate_step3'
import corporate_step4 from '@/components/website/registerSteps/corporate/corporate_step4'
import questionnaire from '@/components/website/questionnaire/questionnaire'

// =============== /user =======================
import login from '@/components/website/user/login'
import home from '@/components/website/user/home'
// import home from '@/components/website/user/home'
// import merchant_home from '@/components/website/user/marchant_home'
import reset_password from '@/components/website/user/reset-password'
import change_password from '@/components/website/user/change-password'
import forgot_password from '@/components/website/user/forgot_password'
import verification from '@/components/website/user/verification'
import after_login from '@/components/website/user/after-login'
import welcome_screen from '@/components/website/user/welcome'
import crypto_deposit from '@/components/website/user/crypto-deposit.vue'
//==============support=========================
import support from '@/components/website/supports/index'
import view from '@/components/website/supports/view'
import help_topic from '@/components/website/supports/help_topic'
import help_centre from '@/components/website/supports/help-centre'
// =============== /deposit-withdrawal ==================
// import receive from '@/components/website/deposit-withdrawal/receive'
import deposit_withdrawal from '@/components/website/deposit-withdrawal'
// ================ /trading ======================
import exchange from '@/components/website/trading/exchange'
import smart_trading from '@/components/website/trading/smart_trading'
// import trading from '@/components/website/trading/trading'
// ================ /markets ======================
import markets from '@/components/website/markets/markets'
import portfolio from '@/components/website/portfolio/portfolio'
// =============== /deposit-withdraw =======================   not in use
// import deposit_withdraw from '@/components/website/deposit-withdraw/deposit-withdraw'
// import withdrawal_verify from '@/components/website/deposit-withdraw/withdrawal-verify'
//import withdraw from '@/components/website/deposit-withdraw/withdraw'
// ================== /history ====================
// import order_history from '@/components/website/history/order-history'
import transaction_history from '@/components/website/transaction-history/transaction-history'
import transaction_history_detail from '@/components/website/transaction-history/transaction-history-detail'
// ================ /address ======================
import ip_whiteList from '@/components/website/ip-whiteList/ip-whiteList'
// ================ payment ======================
import paymentmethods from '@/components/website/payment/paymentmethods'
// =============== /account=======================
import accountprofile from '@/components/website/account/accountprofile'
import logininformation from '@/components/website/account/logininformation'
// import resolutioncenter from '@/components/website/account/resolutioncenter'
// import accountsetting from '@/components/website/account/accountsetting'
// =============== /security =======================
import security from '@/components/website/security/security'
import social_trading from '@/components/website/social-trading/social_trading'
import social_profile from '@/components/website/social-trading/social_profile'
// =============== /wallet =======================
import walletaddress from '@/components/website/wallet/walletaddress'
import wallets from '@/components/website/wallet/wallets'
import wallets_old from '@/components/website/wallet/wallets040522'
import notification from '@/components/website/shared/notification'
// =============== /NotFound =======================
import NotFound from '@/components/website/shared/notFound404'

import api_access from '@/components/website/api-access/api-access'
import settings from '@/components/website/settings/settings'

Vue.use(Router)

const router = new Router({
    mode: 'history',
    routes: [
        { path: '/', name: 'login', component: login },
        { path: '/forgot-password', name: 'forgot_password', component: forgot_password },
        // =============== /reg_step =======================
        { path: '/register', name: 'email_step', component: email_step },
        { path: '/otp-step', name: 'otp_step', component: otp_step },
        { path: '/password-step', name: 'password_step', component: password_step },
        { path: '/forgot/password/:hash', name: 'reset_password', component: reset_password, props: true },
        { path: '/individual-step3-doc', name: 'individual_step3_doc', component: individual_step3_doc },
        {
            path: '/',
            component: website,
            children: [
                { path: '/complete-steps', name: 'after-login', component: after_login },
                { path: '/2fa-screen', name: 'enforce2faRegister', component: enforce2faRegister },
                { path: '/crypto-deposit', name: 'crypto_deposit', component: crypto_deposit },
                { path: '/individual-step1', name: 'individual_step1', component: individual_step1 },
                { path: '/individual-step2', name: 'individual_step2', component: individual_step2 },
                { path: '/individual-step3', name: 'individual_step3', component: individual_step3 },


                { path: '/corporate-step1', name: 'corporate_step1', component: corporate_step1 },
                { path: '/corporate-step2', name: 'corporate_step2', component: corporate_step2 },
                { path: '/corporate-step3', name: 'corporate_step3', component: corporate_step3 },
                { path: '/corporate-step4', name: 'corporate_step4', component: corporate_step4 },
                { path: '/questionnaire', name: 'questionnaire', component: questionnaire },

                // =============== /user =======================
                { path: '/home', name: 'home', component: home },
                // { path: '/dashboard', name: 'marchant_home', component: marchant_home },
                { path: '/change-password', name: 'change_password', component: change_password },
                { path: '/markets', name: 'markets', component: markets },
                { path: '/portfolio', name: 'portfolio', component: portfolio },
                //=====================supports============================================
                { path: '/support/:tabName', name: 'support', component: support },
                { path: '/help-topic', name: 'help_topic', component: help_topic },
                { path: '/help-centre', name: 'help_centre', component: help_centre },
                { path: '/view', name: 'view', component: view, props: true },


                { path: '/exchange', name: 'exchange', component: exchange },
                { path: '/smart-trading', name: 'smart_trading', component: smart_trading },
                // { path: '/trading', name: 'trading', component: trading },
                { path: '/deposit-withdrawal', name: 'deposit_withdrawal', component: deposit_withdrawal },
                // { path: '/deposit-withdraw', name: 'deposit-withdraw', component: deposit_withdraw },
                // { path: '/receive', name: 'receive', component: receive },
                //{ path: '/withdraw', name: 'withdraw', component: withdraw },

                // { path: '/order-history', name: 'order-history', component: order_history },
                { path: '/transaction-history', name: 'transaction-history', component: transaction_history },
                { path: '/transaction-history-detail', name: 'transaction-history-detail', component: transaction_history_detail },

                { path: '/ip-whiteList', name: 'ip-whiteList', component: ip_whiteList },
                { path: '/wallet-address', name: 'wallet-address', component: walletaddress },
                { path: '/payment-methods', name: 'payment-methods', component: paymentmethods },

                { path: '/account-profile', name: 'account-profile', component: accountprofile },
                { path: '/verification', name: 'verification', component: verification },
                { path: '/security', name: 'security', component: security },
                { path: '/social-trading', name: 'social_trading', component: social_trading },
                { path: '/social-profile', name: 'social_profile', component: social_profile },
                { path: '/login-information', name: 'login-information', component: logininformation },
                // { path: '/resolution-center', name: 'resolution-center', component: resolutioncenter },
                // { path: '/account-setting', name: 'account-setting', component: accountsetting },
                { path: '/notification', name: 'notification', component: notification },
                { path: '/welcome', name: 'welcome', component: welcome_screen },

                { path: '/wallets', name: 'wallets', component: wallets },
                { path: '/wallets-old', name: 'wallets_old', component: wallets_old },
                { path: '/developer-option', name: 'api_access', component: api_access },
                { path: '/settings', name: 'settings', component: settings },

                // { path: '/withdrawal-verify', name: 'withdrawal-verify', component: withdrawal_verify },
            ]
        },
        { path: '*', name: 'Not Found', component: NotFound }
    ]
})

router.beforeEach((to, from, next) => {
    let userStateVariable = store.state.user
    // console.log('============================>', to, from);
    if (from.query.transfer || to.query.transfer) {
        let transfer = (from.query.transfer) ? from.query.transfer : to.query.transfer
        localStorage.setItem('transfer_token', transfer)
        // if(userStateVariable != null && 'loggedIn' in userStateVariable && userStateVariable.loggedIn){
        //     // console.log('aaaaaaaaaaaaa')
        //     localStorage.setItem('transfer_login', '1')
        // }
    }
    window.scrollTo(0, 0)
    if (userStateVariable == '') { userStateVariable = {} }
    /*if(to.name == 'email_step' && ((userStateVariable == null || !'loggedIn' in userStateVariable) || !userStateVariable.loggedIn)){
        next({ name: 'login' })
    }else*/ if (to.name !== 'login' && to.name !== 'forgot_password' && to.name !== 'reset_password' && to.name !== 'email_step' && to.name !== 'otp_step' && to.name !== 'password_step' && ((userStateVariable == null || !'loggedIn' in userStateVariable) || !userStateVariable.loggedIn)) {
        next({ name: 'login' })
    } else if (to.name != 'enforce2faRegister' && to.name != 'enforce2faRegister' && userStateVariable && 'loggedIn' in userStateVariable && userStateVariable.loggedIn && parseInt(userStateVariable.profile.gAuthenticatorEnabled) == 0) {
        next({ name: 'enforce2faRegister' })
    } else if (to.name != 'enforce2faRegister' && to.name != 'crypto_deposit' && userStateVariable && 'loggedIn' in userStateVariable && userStateVariable.loggedIn && 'walletInterface' in userStateVariable && userStateVariable.walletInterface) {
        next({ name: 'crypto_deposit' })
    } // individual step 1 resticted to home
    else if ( (userStateVariable && 'loggedIn' in userStateVariable) && parseInt(userStateVariable.lead_type) == 0 && to.name != 'individual_step1' && parseInt(userStateVariable.step) == 0 && parseInt(userStateVariable.profile.gAuthenticatorEnabled) == 1) {
        next({ name: 'individual_step1' })
    } // individual step 2 resticted to home 
    else if ( (userStateVariable && 'loggedIn' in userStateVariable) && parseInt(userStateVariable.lead_type) == 0 && to.name != 'individual_step2' && parseInt(userStateVariable.step) == 1 && parseInt(userStateVariable.profile.gAuthenticatorEnabled) == 1) {
        next({ name: 'individual_step2' })
    } else if ((to.name == 'corporate_step1' || to.name == 'corporate_step2' || to.name == 'corporate_step3' || to.name == 'corporate_step4') && ((userStateVariable != null || 'loggedIn' in userStateVariable) || userStateVariable.loggedIn) && parseInt(userStateVariable.lead_type) == 0) {
        next({ name: 'home' })
    } else if ((to.name == 'corporate_step1' || to.name == 'corporate_step2' || to.name == 'corporate_step3' || to.name == 'corporate_step4') && ((userStateVariable != null || 'loggedIn' in userStateVariable) || userStateVariable.loggedIn) && (parseInt(userStateVariable.lead_type) == 1 && parseInt(userStateVariable.step) >= 4)) {
        next({ name: 'home' })
    } else if ((to.name == 'questionnaire') && ((userStateVariable != null || 'loggedIn' in userStateVariable) || userStateVariable.loggedIn) && (parseInt(userStateVariable.lead_type) == 1) && (parseInt(userStateVariable.tier) <= 5) ) {
        next({ name: 'home' })
    } else if ((to.name == 'individual_step1' || to.name == 'individual_step2' || to.name == 'individual_step3' || to.name == 'individual_step3_doc') && ((userStateVariable != null || 'loggedIn' in userStateVariable) || userStateVariable.loggedIn) && parseInt(userStateVariable.lead_type) == 1) {
        next({ name: 'home' })
    } else if ((to.name == 'individual_step1' || to.name == 'individual_step2' || to.name == 'individual_step3' || to.name == 'individual_step3_doc') && ((userStateVariable != null || 'loggedIn' in userStateVariable) || userStateVariable.loggedIn) && (parseInt(userStateVariable.lead_type) == 0 && parseInt(userStateVariable.step) >= 3)) {
        next({ name: 'home' })
    } else if (userStateVariable !== null && 'loggedIn' in userStateVariable && userStateVariable.loggedIn && (to.name == 'login' || to.name == 'forgot_password' || to.name == 'reset_password' || to.name == 'email_step' || to.name == 'otp_step' || to.name == 'password_step')) {
        //if transfer token ayega then save hoga localstorage mein 
        //refresh data api hit honi chahiye token ke sath
        //vo variable check kia jaye
        //page open kia jaye
        // console.log('--------------------------->',from,to)

        next({ name: 'home' })
    } else if (userStateVariable !== null && 'loggedIn' in userStateVariable && userStateVariable.loggedIn && parseInt(userStateVariable.fresh_user) != 0 && (to.name == 'login' || to.name == 'forgot_password' || to.name == 'reset_password' || to.name == 'email_step' || to.name == 'otp_step' || to.name == 'password_step' || to.name == 'welcome')) {
        next({ name: 'home' })
    }

    else next()
})
export default router


// WEBPACK FOOTER //
// ./src/router/index.js